/**
 * serviceOrderTabCounts - Monta os contadores das abas do modal da OS (BR-OS-026).
 *
 * Função pura: recebe os totais já calculados pelas RPCs das abas
 * (checklists, estoque, pausas, conversas e timeline) e devolve o mapa
 * de badges. Mantida fora do componente para ser testável.
 *
 * CHANGELOG:
 *   RELEASE: 2026-10-16 v1.1.0 - Contador da aba Remessas.
 *   RELEASE: 2026-10-09 v1.0.0 - Criação inicial.
 */
import type { ServiceOrderModalTab } from '@/components/service-orders/details/ServiceOrderModalTabs';

export interface ServiceOrderTabCountsInput {
  activity: number;
  history: number;
  checklists: number;
  products: number;
  pauses: number;
  chat: number;
  /** Agendamento ativo: possui início e a OS não está cancelada */
  scheduledStart: string | null | undefined;
  status: string | null | undefined;
  /** BR-OS-030: total de linhas do histórico de agendamentos (opcional) */
  schedules?: number;
  /** Logística: total de remessas vinculadas (opcional) */
  shipments?: number;
  /** v1.2.0: total de serviços da aba Itens (opcional) */
  items?: number;
}

export function buildServiceOrderTabCounts(i: ServiceOrderTabCountsInput): Partial<Record<ServiceOrderModalTab, number>> {
  return {
    activity: i.activity,
    history: i.history,
    checklists: i.checklists,
    products: i.products,
    pauses: i.pauses,
    chat: i.chat,
    shipments: i.shipments ?? 0,
    items: i.items ?? 0,
    // BR-OS-030: total do histórico de agendamentos quando informado
    schedule: i.schedules ?? (i.scheduledStart && i.status !== 'cancelled' ? 1 : 0),
  };
}

/** Aba Chat só aparece quando o cliente da OS tem contato principal. */
export function hiddenServiceOrderTabs(contactId: string | null | undefined): ServiceOrderModalTab[] {
  return contactId ? [] : ['chat'];
}
